import { IAddFormPublishTermsResponse } from '../../../../repositories/billing-tariffs/v2/add-form/publish-terms';
import { IPromotionService } from '../../../../reducers/v2';
import { defaultTo } from 'ramda';
import { EUnavailableReason } from '../../../../types/reducers/publishTerms';
import { EServices } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PublishTerm';

export const mapPromotionServices = (response: IAddFormPublishTermsResponse): IPromotionService[] => {
  if (!response.terms) {
    return [];
  }

  const isAutobrokerEnabled = response.auction?.strategyInfo?.isEnabled || false;

  return response.terms.map(term => ({
    disabled: isAutobrokerEnabled && term.services[0] === EServices.Paid,
    selected: term.isDefault,
    price: term.baseAuctionBet || 0,
    type: term.services[0] as unknown as IPromotionService['type'],
    token: term.periods[0].token || '',
    isAuctionEnabled: false,
    unavailableReasonType: defaultTo(null, term.unavailableReasonType as unknown as EUnavailableReason),
    isRecommended: term.isRecommended,
  }));
};
